import { styled } from '@clickcease/cc-client-components-lib'

export const ModifyPlanBundleStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const ModifyPlanBundleRow = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const ModifyPlanNameTitle = styled('div', {
  fontSize: '$h3',
  fontWeight: '$sb',
  marginBottom: '$8',
})

export const DowngradePlanError = styled('p', {
  marginTop: '$10',
  fontWeight: '$rb',
  fontSize: '$md',
  color: '$error',
})
